module.exports = __webpack_public_path__ + "static/media/IconTemplates_-31.972499c6.svg";